import { useNavigate } from "react-router-dom";
import { PillButton } from "./PillButton";

export const HeroChat = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden">
      <div className="container mx-auto px-3 lg:px-8 pt-6">
        <div className="relative mkt-gradient-hero mkt-grain rounded-[2rem] overflow-hidden px-6 sm:px-10 lg:px-16 py-20 sm:py-28 lg:py-36">
          {/* Soft light streaks */}
          <div className="absolute -right-32 top-10 w-[500px] h-[500px] rounded-full bg-white/10 blur-3xl pointer-events-none" />
          <div className="absolute -left-40 bottom-0 w-[400px] h-[400px] rounded-full bg-white/10 blur-3xl pointer-events-none" />

          <div className="relative max-w-3xl mx-auto text-center text-white">
            <h1 className="text-[44px] sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-black">
              The anonymous feedback tool
              <br className="hidden sm:block" />{" "}
              <span className="inline-block bg-white/95 text-[hsl(var(--mkt-primary-deep))] rounded-full px-5 py-1 align-middle">
                HR actually trusts
              </span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-white/85 font-medium">
              Get the honest truth about culture, retention, and morale — by chatting to your AI advisor. Setup in 5 minutes.
            </p>

            <div className="mt-10 flex items-center justify-center gap-3 flex-wrap">
              <PillButton variant="primary" size="lg" onClick={() => navigate("/auth?mode=signup")}>
                Create anonymous page
              </PillButton>
              <PillButton variant="white" size="lg" onClick={() => navigate("/contact")}>
                Book a demo
              </PillButton>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/75">
              <span>Free 15-day trial</span><span aria-hidden>·</span>
              <span>No credit card</span><span aria-hidden>·</span>
              <span>GDPR compliant</span><span aria-hidden>·</span>
              <span>Live in 5 minutes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
